import { z } from "zod";

export const DTOGitOrganization = z.object({
  id: z.string(),
  name: z.string(),
  url: z.string(),
  slug: z.string(),
});
export type DTOGitOrganization = z.infer<typeof DTOGitOrganization>;

export const DTOGitProject = z.object({
  id: z.string(),
  name: z.string(),
  url: z.string(),
  slug: z.string(),
});
export type DTOGitProject = z.infer<typeof DTOGitProject>;

export const DTOGitRepository = z.object({
  id: z.string(),
  name: z.string(),
  url: z.string(),
  slug: z.string(),
  defaultBranch: z.string().optional(),
});
export type DTOGitRepository = z.infer<typeof DTOGitRepository>;

export const DTOGitBranch = z.object({
  name: z.string(),
  lastCommitId: z.string(),
});
export type DTOGitBranch = z.infer<typeof DTOGitBranch>;
